<script setup lang="ts">
import { computed } from 'vue'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useAssetStore } from '@/stores/assetStore.ts'
import type Tech from '@/types/Tech.ts'
import ModalTechQueueItem from './ModalTechQueue/ModalTechQueueItem.vue'

const gameStore = useGameStore()
const assetStore = useAssetStore()

// Get queued techs
const queuedTechs = computed(() => {
  if (!gameStore.playerTechQueue || !gameStore.playerTechQueue.queue) return []
  return gameStore.playerTechQueue.queue
    .map((id: number) => assetStore.findTechById(id))
    .filter((tech): tech is Tech => tech !== null)
})
</script>

<template>
  <SmallModel title="Research Queue">
    <div class="pt-2 px-2">
      <StandardCard class="mb-2">
        <div class="text-slate-400">
          The research queue is a list of technologies that will be targeted after the current
          target is completed.
        </div>
      </StandardCard>

      <!-- Current research target -->
      <!-- <div v-if="currentTech">
        <ModalTechQueueItem :tech="currentTech" />
      </div> -->

      <div
        v-if="queuedTechs.length === 0"
        class="px-2 py-3 mb-2 bg-slate-800 rounded-md text-slate-400"
      >
        No technologies in queue
      </div>
      <div v-else class="">
        <div v-for="tech in queuedTechs" :key="tech.id" class="flex items-center justify-between">
          <ModalTechQueueItem :tech="tech" />
        </div>
      </div>
    </div>
  </SmallModel>
</template>
